import { render, staticRenderFns } from "./Referrals.vue?vue&type=template&id=022c90ae&scoped=true&"
import script from "./Referrals.vue?vue&type=script&lang=ts&"
export * from "./Referrals.vue?vue&type=script&lang=ts&"
import style0 from "./Referrals.vue?vue&type=style&index=0&id=022c90ae&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "022c90ae",
  null
  
)

export default component.exports